import { Resource } from "../resource"

export class Component extends Resource{
    name: string | any
    description: string | any
    created: Date | any
} 